import React from 'react';
import { I18nContextProvider } from '@ecg-marktplaats/js-react-i18n';
import { hydrateRoot } from 'react-dom/client';
import { Header } from '@hz-design-system/web-ui';

import CategoryMenuBarApp from '../../apps/CategoryMenuBar/CategoryMenuBar';
import SellPageContent from '../../apps/CarsPageContent/components/SellPageContent';

import { trackGAEvent } from '../../utils/gaTracking';

import '../../../scss/l1CarsSellPage.scss';
// server side only components styles for this page
import '../../../../server/pages/l1CarsSellPage.styles';
import { TEnvConfigCars } from 'types/TServerContext';

// eslint-disable-next-line require-await
export default async (i18n) => {
  const appState = window.__CONFIG__ || {
    carsCategoryLinks: [],
  };
  const environment = (window.__ENV_CONFIG__ as TEnvConfigCars) || {};
  const headerConfig = window.__HEADER_CONFIG__ || {};
  const headerRoot = document.getElementById('header-root');
  const categoryMenuBarRoot = document.getElementById('category-menu-bar-root');
  const pageContentRoot = document.getElementById('page-content-root');

  // Header is server side rendered in express-react library
  hydrateRoot(headerRoot!, <Header headerConfig={headerConfig} trackGAEvent={trackGAEvent} />);

  hydrateRoot(
    categoryMenuBarRoot!,
    <I18nContextProvider i18nInstance={i18n}>
      <CategoryMenuBarApp appState={appState} />
    </I18nContextProvider>,
  );

  hydrateRoot(
    pageContentRoot!,
    <I18nContextProvider i18nInstance={i18n}>
      <SellPageContent appState={appState} environment={environment} />
    </I18nContextProvider>,
  );
};
